<template>
  <Transition name="slide-fade">
    <div class="list-wrap">
      <swiper :slides-per-view="1.3"
              :space-between="8"
              @swiper="onSwiper"
              @slideChange="handleSlideEnd">
        <swiper-slide v-for="(dataObj,index) in companyList"
                      :key="'mobile-spaceList-key-'+index">
          <div class="slide-wrap"
               @click="goToSpacePage(dataObj.space_id)">
            <div class="image-wrap">
              <img :src="picUrl+dataObj.photo_url"
                   alt="">
            </div>
            <div class="space-wrap">
<!--              <div class="name">{{ dataObj.brand_name }}</div>-->
              <div class="space_name">{{ dataObj.space_name }}</div>

              <div v-show="dataObj.traffics.length>0"
                   class="flex items-center absolute bottom-[32px]">
                <svg-icon name="directions_railway"
                          size="16"
                          class="mr-[2px]"/>
                <span class="text-[14px] text-osn-dark-grey-00">{{ dataObj.traffics[0]?.mrt_station + '捷運站' }}</span>
                <span class="ml-[3px] text-osn-grey-01">
                  {{ $t('space.walking_time', {t: dataObj.traffics[0]?.walking_time}) }}
                </span>
              </div>
              <div class="flex items-center absolute bottom-[8px]">
                <svg-icon name="groups"
                          size="16"
                          class="mr-[2px]"/>
                <div class="text-[14px] text-osn-grey-01">{{ dataObj.number_of_people_max + '人' }}</div>
              </div>

              <div class="absolute bottom-[8px] right-0 flex justify-end mr-[12px] items-baseline">
                <span class="font-semibold text-[18px] text-osn-dark-grey-00 mr-[4px]">
                  {{ parseFormatCheapestRentPrice(dataObj.rent.rent_groups) }}
                </span>
                <span class="font-normal text-osn-grey-01 text-[14px]">
                  {{ `/${parseFormatCheapestRentType(dataObj.rent.rent_groups)}` }}
                </span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </Transition>
</template>

<script setup>
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import {nextTick, onMounted, ref, watch} from "vue";

import {useSpaceInfoStore} from '@/stores/spaceInfo'
import {useGoTo} from "@/composables/useGoTo";
import {parseFormatCheapestRentPrice, parseFormatCheapestRentType} from "~/utils/newPriceTool.ts";

const router = useRouter()
const route = useRoute();
const emit = defineEmits(['onCompanySelected'])
const compSwiper = ref(null)
const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const typeCategoryId = ref(import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID)

const spaceInfoStore = useSpaceInfoStore()
const {goToSpacePage} = useGoTo()
const props = defineProps({
  companyList: {
    type: Array
  }
})
defineExpose({
  slideTo
});
onMounted(() => {
  watch(
      () => props.companyList,
      (newCompanyList) => {
        nextTick(() => {
          const index = newCompanyList.findIndex((item) => item.space_id === parseInt(spaceInfoStore.getSpaceID));

          if (index === -1) {
            return;
          }
          slideTo(index);
        });
      },
      {immediate: true} // 立即觸發一次，以便處理已經存在的資料
  );
});

function onSwiper(swiper) {
  compSwiper.value = swiper
}

const handleSlideEnd = (data) => {
  emit('onCompanySelected', data.activeIndex);
}

function slideTo(index) {
  nextTick(() => {
    compSwiper.value?.slideTo(index, 333, false);
  });
}


</script>

<style scoped
       lang="scss">
:deep(.swiper-wrapper) {
  @apply flex;
  > div:first-child {
    @apply mobile:pl-[10px];
  }
}

.list-wrap {
  @apply absolute w-full h-fit bottom-[8px];
  z-index: 0;

  .slide-wrap {
    @apply relative w-full h-[220px] text-white bg-white rounded-[16px] pb-[1px];

    .image-wrap {
      @apply relative w-full rounded-t-[16px] overflow-hidden h-[88px];
      img {
        @apply w-full h-[88px] object-cover;
      }
    }

    .space-wrap {
      @apply relative h-[130px] px-[12px] flex flex-col justify-items-start;

      .name {
        @apply text-osn-grey-01 text-[14px] mt-[8px] truncate;
      }

      .space_name {
        @apply mt-[8px] mb-[4px] h-[44px] text-[14px] text-osn-dark-grey-00 font-bold line-clamp-2;
      }
    }
  }
}


/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
